import IRestServiceFilters from "./IRestServiceFilters";
import IRestServiceOrders from "./IRestServiceOrders";
import {RouteParametersFromUrl} from "../../../redux/selectors/Routes";
import IRestServiceAggregations from "./IRestServiceAggregations";
import IRestServiceGroupByList from "./IRestServiceGroupByList";
import IRestResource from "./IRestResource";

export const RestServiceOptions = {
    FORMAT: {
        DEFAULT: 'default',
        PIVOT: 'pivot'
    }
}

export default interface IRestServiceOptions {
    limit?: number,
    page?: number,
    order?: IRestServiceOrders
    filters?: IRestServiceFilters,
    aggregations?: IRestServiceAggregations,
    groupBy?: IRestServiceGroupByList
    cache?: boolean,
    timeOut?: number,
    depth?: number,
    fileUpload?: boolean
    route?: RouteParametersFromUrl
    resource?: {object: IRestResource, className: string}
    [x: string]: any
    format?: 'default' | 'pivot' | string
    multiple?: boolean
    _no_error_messages?: boolean
}